'use client';
import { classes } from '@/utils/classes/classes';
import { ROUTES } from '@/utils/constants';
import dynamic from 'next/dynamic';
import Link from 'next/link';
import './styles/default.scss';
import { useGlobalContext } from '@/store/contexts/global-context';
import { useAccountUm } from '@/hooks/use-account-um';

type RewardMachineInfoButtonProps = {
    extraClassName: string;
};

const SvgLoader = dynamic(() => import('@/app/elements/svg/loader').then((mod) => mod.SvgLoader), { ssr: false });
// TODO https://fanduel.atlassian.net/browse/CASPROMO-13604 move to RH
export const RewardMachineInfoButton: React.FC<RewardMachineInfoButtonProps> = ({ extraClassName }) => {
    const { isLoggedIn } = useGlobalContext();
    const { triggerLogin } = useAccountUm();

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (!isLoggedIn) {
            e.preventDefault();
            triggerLogin();
        }
    };

    return (
        <Link
            href={ROUTES.REWARD_MACHINE_INFO}
            data-reward-machine-info-link
            data-testid="reward-machine-info-button"
            className={classes('rm-info-button', 'info-button--desktop', extraClassName)}
            onClick={handleClick}>
            <SvgLoader iconName="info" />
        </Link>
    );
};
